import { VehicleFuelType } from '@api/index';
import RadioButton from '@rio-cloud/rio-uikit/RadioButton';
import { FormattedMessage } from 'react-intl';

export const ALL_VEHICLE_FUEL_TYPES = [
    VehicleFuelType.DIESEL,
    VehicleFuelType.ELECTRIC,
    VehicleFuelType.GAS,
    VehicleFuelType.HYDROGEN,
    VehicleFuelType.UNKNOWN,
];
const DIESEL_VEHICLE_TYPES = [VehicleFuelType.DIESEL, VehicleFuelType.GAS, VehicleFuelType.UNKNOWN];
const ELECTRIC_VEHICLE_FUEL_TYPE = [VehicleFuelType.ELECTRIC];

const checkVehicleFuelTypes = (
    fuelTypesArray1: VehicleFuelType[],
    fuelTypesArray2: VehicleFuelType[],
) => {
    return JSON.stringify(fuelTypesArray1) === JSON.stringify(fuelTypesArray2);
};
type TreeFilterButtonsV2Props = {
    onSelectionChange: (fuelTypes: VehicleFuelType[]) => void;
    selectedFuelTypes: VehicleFuelType[];
};

const TreeFilterButtonsV2 = ({
    onSelectionChange,
    selectedFuelTypes,
}: TreeFilterButtonsV2Props) => {
    return (
        <div className="display-flex flex-column margin-x-25">
            <span className="text-medium padding-bottom-5 text-size-12">
                <FormattedMessage id="select.engineType" />
            </span>
            <div
                className="display-flex justify-content-between
 column-gap-25 bg-white rounded border-style-solid border-width-1 border-color-light shadow-subtle"
                style={{ padding: '6px 9px' }}
                data-test="vehicle-fuel-toggle"
            >
                <RadioButton
                    name="vehicleFilter"
                    value="all"
                    checked={checkVehicleFuelTypes(selectedFuelTypes, ALL_VEHICLE_FUEL_TYPES)}
                    onChange={() => onSelectionChange(ALL_VEHICLE_FUEL_TYPES)}
                    label={<FormattedMessage id="vehicleFuelType.all" />}
                    data-test="fleet-segment-all"
                    data-track-ga-event-trigger="click"
                    data-track-ga-event-name="perform_fleet_segment_applied"
                    data-track-ga-event-element-name="all"
                />
                <RadioButton
                    name="vehicleFilter"
                    value="electric"
                    checked={checkVehicleFuelTypes(selectedFuelTypes, ELECTRIC_VEHICLE_FUEL_TYPE)}
                    onChange={() => onSelectionChange([VehicleFuelType.ELECTRIC])}
                    label={<FormattedMessage id="vehicleFuelType.electric" />}
                    data-test="fleet-segment-electric"
                    data-track-ga-event-trigger="click"
                    data-track-ga-event-name="perform_fleet_segment_applied"
                    data-track-ga-event-element-name="electric"
                />
                <RadioButton
                    name="vehicleFilter"
                    value="fuel"
                    checked={checkVehicleFuelTypes(selectedFuelTypes, DIESEL_VEHICLE_TYPES)}
                    onChange={() =>
                        onSelectionChange([
                            VehicleFuelType.DIESEL,
                            VehicleFuelType.GAS,
                            VehicleFuelType.UNKNOWN,
                        ])
                    }
                    label={<FormattedMessage id="vehicleFuelType.fuel" />}
                    data-test="fleet-segment-fuel"
                    data-track-ga-event-trigger="click"
                    data-track-ga-event-name="perform_fleet_segment_applied"
                    data-track-ga-event-element-name="fuel"
                />
            </div>
        </div>
    );
};

export default TreeFilterButtonsV2;
